export default __webpack_public_path__ + "assets/json/b2906a66354ce7216c2ee61c553e30fb.json";